import { type FC, useContext, useMemo } from "react";
import { DragDropRenderer } from "./DragDropRenderer";
import { DRAG_DROP_ROOT_CONTAINER_ID, type DragDropEditItemMap, DragDropEditorContext } from "./DragDropTypes";

interface Props {
    id?: string;
    items: DragDropEditItemMap;
    data: Record<string, unknown>;
}

export const DragDropPreview: FC<Props> = ({
    id = DRAG_DROP_ROOT_CONTAINER_ID,
    items,
    data,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const components = useMemo(() => {
        return manager.toArray(id);
    }, [ id, manager ]);

    return (
        <DragDropRenderer
            components={components}
            items={items}
            data={data}
        />
    );
};
